import {abstractFilter} from './../abstractFilter';
function F() {
    return (F.is(this) ? this.init : F.F).apply(this, Array.prototype.slice.call(arguments));
}

var P = F.leu_extend(abstractFilter).prototype;


P.apply_filter = function (current_value) {
    return current_value;// pass any input value
};

export default F;


